<ng-container *ngIf="phase">
    <shared-active-slots-item-phase [phase]="phase"
        class="noSlot noVerificationCode noGoods noDocks"></shared-active-slots-item-phase>
    <form class="col-x" [formGroup]="rForm">
        <datehour-picker class="col-20" name="arrivedAt"
            placeholder="{{'PHASE.CHANGEDATES.ARRIVEDAT.CAPTION' | translate}}" [(ngModel)]="phase.arrivedAt"
            formControlName="arrivedAt">
        </datehour-picker>
        <datehour-picker class="col-20" name="completedAt"
            placeholder="{{'PHASE.CHANGEDATES.COMPLETEDAT.CAPTION' | translate}}" [(ngModel)]="phase.completedAt"
            formControlName="completedAt">
        </datehour-picker>
    </form>
    <div class="col-x">
        <button class="action button-form" (click)="save()" [ngClass]="getsavebuttonclass()">{{ 'MAINTENANCE.ACCEPT' |
            translate }}</button>
    </div>
</ng-container>